import { render, staticRenderFns } from "./RfqsForm.vue?vue&type=template&id=46565252"
import script from "./RfqsForm.vue?vue&type=script&lang=js"
export * from "./RfqsForm.vue?vue&type=script&lang=js"
import style0 from "./RfqsForm.vue?vue&type=style&index=0&id=46565252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports